import apiClient from './apiClient';

const Url = `/dashboard`;

export const getTotalData = async (props) => {
    try{
        let response = await apiClient.get(`${Url}/get-totals`);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

export const getOrderData = async (props) => {
    try{
        let response = await apiClient.get(`${Url}/order-data`);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

export const getUpcomingFollowups = async (props) => {
    try {
        const response = await apiClient.get(`${Url}/upcoming-followups`);
        if (response && response.status === 200) return response.data;
        return response;
    } catch (error) {
        return error;
    }
}

export const getDashboardLayout = async (props) => {
    try {
        const response = await apiClient.get(`${Url}/layout`);
        if (response && response.status === 200) return response.data;
        return response;
    } catch (error) {
        return error;
    }
}

export const saveDashboardLayout = async (props, layout) => {
    try {
        const response = await apiClient.put(`${Url}/layout`, layout);
        if (response && response.status === 200) return response.data;
        return response;
    } catch (error) {
        return error;
    }
}
